export default __webpack_public_path__ + "assets/sync.52ef66f8.svg";